import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true, error });
  }

  render() {
    if (this.state.error) {
      return (
        <div>Algo de errado aconteceu. Por favor, actualize a página :)</div>
      );
    }
    return this.props.children;
  }
}
